/**
 * Manning-stats filter value and helpers — split out of StatsFilterPopover.tsx
 * so that file exports only the component (react-refresh/only-export-components
 * flags a component file that also exports runtime consts/functions).
 */

export interface StatsFilterValue {
  /** null = every officer (no officer filter); a Set is the officers to include. */
  officerKeys: Set<string> | null;
  /** HHMM, or null for the start of the shift. */
  start: string | null;
  /** HHMM, or null for the end of the shift. */
  end: string | null;
}

export const EMPTY_STATS_FILTER: StatsFilterValue = { officerKeys: null, start: null, end: null };

/** Whether a filter value actually restricts anything (vs. the no-op default). */
export function isStatsFilterActive(v: StatsFilterValue, totalOfficers: number): boolean {
  return (v.officerKeys !== null && v.officerKeys.size !== totalOfficers) || !!v.start || !!v.end;
}
